import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';

export type ExpertHubStateFragmentFragment = {
  __typename?: 'ExpertHubStateType';
  onboardingStep?: string | null;
  onboardingMode?: Types.OnboardingModeEnum | null;
  source?: Types.ExpertHubSourceEnum | null;
  onboardingFinishedAt?: any | null;
  extractionState?: Types.ExpertHubExtractionStateEnum | null;
  cvReuploadAvailable: boolean;
};

export const ExpertHubStateFragmentFragmentDoc = gql`
  fragment ExpertHubStateFragment on ExpertHubStateType {
    onboardingStep
    onboardingMode
    source
    onboardingFinishedAt
    extractionState
    cvReuploadAvailable
  }
`;
